import { render, staticRenderFns } from "./BookBuy.vue?vue&type=template&id=72384dba"
import script from "./BookBuy.vue?vue&type=script&lang=js"
export * from "./BookBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports